<template>
  <OwnInput
    v-model="phoneNumber"
    :error="error"
    :placeholder="placeholder"
    @input="formatUIPhone"
  />
</template>
<script>
import { OwnInput } from '@/ui'
import { mapModel } from '@/utils/computed'
import { formatPhoneNumber } from '@/utils/format/phone'

const filterPhoneNumber = (newValue) => {
  let targetValue = newValue

  if (targetValue.startsWith('+')) {
    targetValue = targetValue.slice(2)
  }

  const chars = targetValue.split('')

  return chars
    .filter((char) => !isNaN(parseInt(char)))
    .slice(0, 10)
    .join('')
}

export default {
  name: 'PhoneInput',
  components: {
    OwnInput,
  },
  props: {
    /**
     * Accessibility ID
     */
    accessibilityId: { type: String, default: undefined },

    /**
     * Has Error
     */
    error: { type: Boolean, default: false },

    /**
     * Placeholder Text
     */
    placeholder: { type: String, default: undefined },

    /**
     * @model Value
     */
    value: { type: String, default: undefined },
  },
  data() {
    return {
      isInitialized: false,
      phoneNumber: '',
    }
  },
  computed: {
    ...mapModel('inputValue'),
  },
  watch: {
    phoneNumber(newPhone) {
      const { isInitialized } = this

      if (isInitialized) {
        this.setModelPhone(newPhone)
      }
    },
  },
  created() {
    const { inputValue } = this

    if (inputValue) {
      const filteredPhoneNumber = filterPhoneNumber(inputValue)
      const formattedPhoneNumber = formatPhoneNumber(filteredPhoneNumber)

      this.phoneNumber = formattedPhoneNumber
    }

    this.$nextTick(() => {
      this.isInitialized = true
    })
  },
  methods: {
    formatUIPhone() {
      const match = this.phoneNumber
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      const endResult = match[3] ? '-' + match[3] : ''

      this.phoneNumber = !match[2]
        ? match[1]
        : '(' + match[1] + ') ' + match[2] + endResult
    },
    setModelPhone(newPhoneNumber) {
      const filteredPhoneNumber = filterPhoneNumber(newPhoneNumber)

      this.inputValue = `+1${filteredPhoneNumber}`
    },
  },
}
</script>
